import React from "react";
import { useNavigate } from "react-router-dom";

const FREDOKA = { fontFamily: "'Fredoka', sans-serif" };

/**
 * Shared Stories | Storybooks switcher used by Library and the Storybooks
 * (Reading Den) page so both surfaces stay equally reachable.
 */
const LibraryContentTabs = ({ active = "stories", className = "", style = {} }) => {
  const navigate = useNavigate();

  const tabs = [
    { id: "stories", label: "Stories", to: "/library" },
    { id: "storybooks", label: "Storybooks", to: "/library?tab=storybooks" },
  ];

  return (
    <div
      className={`inline-flex items-center p-1 ${className}`}
      role="tablist"
      aria-label="Library content"
      style={{
        background: "#FFFFFF",
        border: "2px solid rgba(11,26,51,0.08)",
        borderRadius: 999,
        boxShadow: "0px 2px 0px rgba(11,26,51,0.06)",
        ...style,
      }}
    >
      {tabs.map((tab) => {
        const selected = active === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => navigate(tab.to)}
            className="transition active:scale-[0.98]"
            style={{
              ...FREDOKA,
              padding: "10px 18px",
              borderRadius: 999,
              border: "none",
              cursor: "pointer",
              fontWeight: 700,
              fontSize: 14,
              color: selected ? "#FFFFFF" : "#5A6B85",
              background: selected ? "#0065F8" : "transparent",
              boxShadow: selected ? "0px 3px 0px #073B8E" : "none",
            }}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default LibraryContentTabs;
